<template>
  <div class="container create-apple-mail">
    <div class="row">
      <div class="col-sm">
        <h1>{{ pageTitle }}</h1>
      </div>
    </div>
    <div class="row" v-for="(item, key) in stepContent" :key="item.title">
      <div class="col-sm">
        <transition-group appear name="fade" :duration="1000">
          <h4 :key="item.title">{{ key + 1 }}. {{ item.title }}</h4>
          <div :key="item.content" v-html="item.content" />
          <img :key="item.image" :src="item.image" alt="" />
        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'create-apple-mail',
  data () {
    return {
      pageTitle: 'How to create and install a HTML email signature in Apple Mail',
      stepContent: [
        {
          title: 'Create a new signature',
          image: './assets/images/create-html-email-mac/step1.png',
          content: 'Go to Mail > Preferences… > Signatures. Select the email account you want to use the new signature with. Most likely this will be your default Exchange account named "Tuff Shed". Click on the “+” to add a new signature.'
        },
        {
          title: 'Set up new signature',
          image: './assets/images/create-html-email-mac/step2.png',
          content: 'Give the new signature a name. We will name it "TS Signature" in this example. Note that the number of signatures have increased by one under your email account. Uncheck box for "Always match my default message font". Make sure the new signature is selected for "Choose Signature". This allows the signature to show up automatically when you compose a new message. Close window and quit Mail.'
        },
        {
          title: 'Check mail settings for viewing',
          image: './assets/images/create-html-email-mac/step3.png',
          content: 'Go to Mail > Preferences… > Viewing. Check box for "Load remote content in messages".  This will allow for extenal images to be loaded into your signature.'
        },
        {
          title: 'Check mail settings for composing',
          image: './assets/images/create-html-email-mac/step4.png',
          content: 'Go to Mail > Preferences… > Composing. Select Rich Text for "Message Format". This allows us to access the awesomeness of HTML!'
        },
        {
          title: 'Copy HTML email signature code',
          image: './assets/images/create-html-email-mac/step5.png',
          content: 'Now its time to head to the "Tuff Shed Email Signature Tool" to generate your email. Tweak the settings to your liking and make sure everything is just right.  Then click on the "Get Source Code" button. This generates the HTML needed to create your email within Apple Mail.'
        },
        {
          title: 'Head over to your signatures folder',
          image: './assets/images/create-html-email-mac/step7.png',
          content: 'To get to your signatures folder. Open your finder application, then Choose Go > Go to Folder...  Once this is selected you want to enter in the following path.  "~/Library/Mail/V6/MailData/Signatures", without the quotes.  Please note, that depending on your Mail version, your version number could be different in this path. Click "Go".'
        },
        {
          title: 'Now update that signature file we created earlier',
          image: './assets/images/create-html-email-mac/step8.png',
          content: 'Look for the file you create earlier.  This file will have the extension ".mailsignature". Notice the Date Modified, should be the most recent file modified or match the time you created the signature in mail. Then choose to open with "Text Editor" or the text editor of your choice.'
        },
        {
          title: 'Select everything below the Mime-Version and replace with the generated HTML code.',
          image: './assets/images/create-html-email-mac/step9.png',
          content: ''
        },
        {
          title: 'Paste HTML code into your signature file, save and lock the file',
          image: './assets/images/create-html-email-mac/step10.png',
          content: 'Once you have your new HTML code in place. Saved the file, then lock it.'
        },
        {
          title: 'Now, lets test out how good your new email signature looks',
          image: './assets/images/create-html-email-mac/step11.png',
          content: 'Open Mail and compose a new message. The new html email signature will appear automatically. If the HTML email signature doesn’t show, make sure the correct email account is selected from the “From” menu.  And check if the correct signature is selected in the "Signature" menu, if you have more than one signature installed. Way to Go! That signature looks awesome!'
        },
        {
          title: 'Congratulations! You now have completed installing your HTML email',
          image: '',
          content: `Hope you didn't event break a sweat.  But if you did encounter problems, need any assistance, or would just like to buy a developer a beer just head over to <a href="mailto:gethelp@tuffshed.com">gethelp@tuffshed.com</a> and tell them Jyn Erso sent you.`
        }
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .container {
    padding-top: 50px;
    padding-bottom: 50px;
  }

  h4 {
    margin-top: 25px;
    margin-bottom: 10px;
  }

  img {
    max-width: 100%;
    margin: 25px 0;
  }
</style>